module.exports = __webpack_public_path__ + "gdpr.png?0d087ed1720b6c84747535b7af5d8934";